<template>
<div>
    <transition name="bounse">
        <div class="snap-task" v-show="$store.state.snapTaskShow" id="snapTask" :style="{height:(42*items.length)+100+'px',top:items.length<=7?(-42*items.length)-115+'px':-400+'px'}" @click.stop="">
            <div class="title">
                <span>{{$t('language.popup.progressBox')}}</span>
                <div class="icon scaling-close dialog-close" @click.stop="snapTaskShowClose()"></div>
            </div>
            <div class="snap-body">
                <div class="snap-content" :style="{height:(42*items.length)+5+'px'}">
                    <div class="snap-transfer" :key="index" v-for="(item,index) in items" @mouseover="hoverCurrent=index" @mouseout="hoverCurrent=-1">
                        <div class="snap-transfer-name" :title="item.name" v-if="!item.uploadData&&item.percent">{{$t('language.common.transferring')}}:"{{item.name}}"</div>
                        <div class="snap-transfer-name" :title="item.name" v-if="!item.uploadData&&!item.percent">{{$t('language.common.ready')}}:"{{item.name}}"</div>
                        <div class="snap-transfer-name" :title="item.name" v-if="item.uploadData">
                            <div style="float: left;">
                                <div style="float:left;">Upload:</div>
                                <div style="float:left;" class="item-name-txt">"{{item.name}}"</div>
                            </div>
                            <div class="failed-transfer-name" v-if="item.status=='failed'">{{item.status}} </div>
                        </div>
                        <div class="snap-progress">
                            <div :class="[item.percent?'snap-ground-start':'']" :style="{width:item.percent+'%'}"></div>
                        </div>
                        <div class="snap-percentage" v-if="item.percent<=100&&!item.uploadData">{{item.percent}}%</div>
                        <div class="snap-percentage" v-if="item.percent>100">100.00%</div>
                         <div class="snap-percentage" v-if="item.percent&&item.uploadData">{{item.percent}}%</div>
                        <div class="snap-percentage" v-if="!item.percent&&item.uploadData">{{$t('language.common.ready')}}...</div>
                        <div class="snap-percentage" v-if="item.percent==undefined&&!item.uploadData">{{$t('language.common.ready')}}...</div>
                        <div v-if="item.percent!=100" class="icon-util snap-remove-position" :class="[index==hoverCurrent?'blue-remove':'']" @click.stop="removeItem(index,item)"></div>
                    </div>
                </div>
                <div class="snap-footer">
                    <div class="icon-util question  explanShow snap-icon-position">
                        <div class="snap-explanation">
                            <font v-html="$t('language.cloudExploer.limitBoxTip')"></font>
                        </div>
                    </div>
                    <button @click.stop="cancelAllItem()" v-show="items.length&&$store.state.cancelAllFlag" class="snap-cancel">{{$t('language.popup.cancel')}}</button>
                    <button class="snap-detail" v-if="$store.state.detailedProgrssData.length" @click.stop="openDetailedProgress()">{{$t('language.popup.detailed')}}</button>
                </div>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
    data: function () {
        return {
            hoverCurrent: -1,
            items: [],//显示临时任务和上传任务的总和
            transferFlag: true,
            crossFlag: false,
        };
    },
    methods: {
        removeItem(index, item) {//删除某一条待获取进度的临时任务
            let that = this;
            if (item.uploadData) { //取消上传文件
                if (item.uploadStart) {//如果该上传任务已经开始，则调浏览器取消接口
                    this.$emit("cancel", item.name);
                }
                $.each(that.$store.state.uploadArr, function (upIndex, upItem) {
                    if (upItem.name == item.name) {
                        that.$store.state.uploadArr.splice(upIndex, 1);//删除在store缓存中的数据
                        return false;
                    }
                });
            }
            if (item.taskId) {//如果该任务是临时任务数据
                item.status = 3;
                let taUnfinish=this.$store.state.detailTabUnfinished;//获取临时任务未成功列表
                $.each(that.$store.state.detailedProgrssData, function (taskIndex, taskItem) {
                    if (taskItem.taskId == item.taskId) {//找到临时任务所有列表的该条数据
                        if (taskItem.itemProgressInfo) {//如果该任务有详情
                            delete taskItem.itemProgressInfo.percent;//删除任务百分比
                            delete taskItem.itemProgressInfo.speed;//删除任务的速度
                        }
                        that.$store.state.retryItems.splice(index, 1);//待传输列表删除
                        taskItem.status = 3;//将状态改为取消
                        if (taskItem.itemProgressInfo) {
                            taskItem.itemProgressInfo.status = 3;
                        }
                         taUnfinish.push(taskItem);//加入临时任务未成功列表
                        commonUtils.runDetailProgressData(that.$parent);//获取下一个的进度
                        that.$forceUpdate();
                        return false;
                    }
                });
                this.$forceUpdate();
                let cancelData=new cloudExploerUtils.cancelData(commonUtils.getUserToLocal().id,4,item.taskId,item.taskId);
                this.Utils.doTasksRequest('cancel', cancelData).then(response => {});
            } else {
                if (item.desId) { //删除未执行的copy copyto数据
                    this.$toast({
                        text: this.$t('language.cloudExploer.cancelFailed'),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                    return false;
                } else if (!item.uploadData) { //删除未执行的同云盘（除谷歌之外的）剪切 copy数据
                    this.$store.state.retryItems.splice(index, 1);
                }
            }
        },
        openDetailedProgress() {
            if (!this.$parent.$refs.detailedProgrss.detailedProgressShow) {
                this.$parent.$refs.detailedProgrss.detailedProgressShow = true;
                this.$parent.$refs.detailedProgrss.activeName = 'first';
            }
        },
        snapTaskShowClose() {
            this.$store.state.snapTaskShow = false;
        },
        cancelAllItem() {//取消所有数据
            this.$parent.$refs.cancelAllDialog.cancelAllShow = true;
            this.$parent.$refs.cancelAllDialog.loading = false;
            this.$parent.$refs.cancelAllDialog.time = 0;
        }
    }
};
</script>

<style>
#snapTask {
    width: 320px;
    /*no*/
    max-height: 400px;
    /*no*/
}

.snap-task {
    box-sizing: border-box;
    border: 1px solid #8a96e3;
    /*no*/
    background-color: #fff;
    position: absolute;
    margin: auto;
    z-index: 90;
    bottom: 0;
    /*no*/
    right: 2%;
    /*no*/
}

.snap-body {
    width: 100%;
    /*no*/
    padding: 10px;
    /*no*/
    box-sizing: border-box;
    position: relative;

}

.snap-content {
    width: 100%;
    font-size: 14px;
    /*no*/
    overflow: auto;
    max-height: 300px;
    /*no*/
}

/*定义滑块，内阴影及圆角*/
.snap-content::-webkit-scrollbar {
    width: 8px;
    /*no*/
    min-height: 5px;
    /*no*/
    background-color: #fff;
}

.snap-content::-webkit-scrollbar-thumb {
    min-height: 5px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.snap-footer {
    width: 97%;
    /*no*/
    position: relative;
    bottom: -5Px;
    left: -2px;
    /*no*/
    left: 0;
    right: 0;
}

.snap-transfer-name {
    color: #6f7886;
    margin-bottom: 5px;
    /*no*/
    width: 250px;
    /*no*/
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    /*no*/
}

.snap-transfer-name div {
    float: left;
}

.snap-transfer-name .item-name-txt {
    width: 150Px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 15Px;
}

.snap-progress {
    width: 219px;
    /*no*/
    height: 12px;
    /*no*/
    border: 1px solid #dde5f2;
    /*no*/
    margin-bottom: 10px;
    /*no*/
    box-sizing: border-box;
    padding: 1px;
    /*no*/
    float: left;
    margin-right: 10px;
    /*no*/
}

.snap-start {
    width: 236px !important;/*no*/
    border: 1px solid #b3bcf6;
    /*no*/
}

.snap-ground-start {
    height: 8px;
    /*no*/
    background-color: #5562b4;
    margin: 0;
    /*no*/
    max-width: 100%;
}

.snap-percentage {
    color: #6f7886;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 12Px;
    float: left;
}

.snap-remove-position {
    float: right;
    position: relative;
    top: -4px;
    /*no*/
}

.snap-detail:hover {
    background-color: #fff;
    cursor: pointer;
}

.snap-detail {
    background-color: #fff;
    border: 1px solid #b3bcf6;
    /*no*/
    color: #5065bc;
    width: auto;
    float: right;
}

.snap-limits {
    font-size: 10px;
    /*no*/
    color: #2e79f6;
    float: left;
    text-decoration: none;
    position: absolute;
    bottom: 10px;
    /*no*/
}

.snap-limits:hover {
    text-decoration: underline;
}

.snap-transfer {
    width: 100%;
    height: 42px;
    /*no*/
    float: left;
}

.snap-button {
    float: right;
}

.bounse-enter-active {
    animation: bounse-in 0.3s;
    transform-origin: 97% 95%;
}

.bounse-leave-active {
    animation: bounse-in 0.3s reverse;
    transform: scale(1, 1);
    transform-origin: 97% 100%;
}

.failed-transfer-name {
    font-size: 15px;
    /*no*/
    float: right !important;
    /*no*/
    color: red;
    position: relative;
    left: -5Px;
}

@keyframes bounse-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(0.6, 1);
    }

    100% {
        transform: scale(0.6, 1);
    }
}

.snap-icon-position {
    position: relative;
    top: 15px;
    /*no*/
    float: left;
    left: 0px;
    /*no*/
}

.snap-cancel {
    width: auto;
    float: right;
    margin-left: 20px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/snap_task_popup.vue